module.exports = __webpack_public_path__ + "img/south.67d097c0.png";